import React from 'react';

function LeftBlock() {
	return(
		<div class="left-col-block blocks">
			<header class="header theiaStickySidebar">
				<div class="profile-img">
					<img src="/images/profile.png" class="img-responsive" alt=""/>
				</div>
				<div class="content">
					<h1 class="text-center">Veduruvada Uday Kumar</h1>
					<div class="r-gradient" style={{textAlign:"center",marginTop:10}}>
						<span class="lead" >Web/PHP Developer</span><br/>
						<span class="lead" >veduruvadauday@gmail.com</span>
					</div>
					
					
					<div class="about-text">
						<p>
							I am a fully professional creative User academics Designer & Developer Involving with latest web designing and technologies is a great feel free to contact creative.
						</p>

						<p>I have been working as a php developer since 2017. I have a love of clean, elegant styling, and I have experience in the production of CSS3 and HTML5 for modern websites. I love creating awesome websites as per my clients need. I think about user experience when I try to craft websites for my clients.</p>

						{/* <p><img src="images/Signature.png" alt="" class="img-responsive"/></p> */}
					</div>

					<ul class="social-icon">
						<li><a href="https://www.facebook.com/uday8712" target="_blank" rel="noreferrer"><i class="fa fa-facebook" aria-hidden="true"></i>Facebook</a></li>
						<li><a href="https://www.linkedin.com/in/veduruvada-uday-kumar" target="_blank" rel="noreferrer"><i class="fa fa-linkedin" aria-hidden="true"></i>Linkedin</a></li>
					</ul>
				</div>
			</header>
		</div>
	)
}

export default LeftBlock;